import { render } from "./NeonTitle.vue?vue&type=template&id=200bbad4&scoped=true"
import script from "./NeonTitle.vue?vue&type=script&lang=js"
export * from "./NeonTitle.vue?vue&type=script&lang=js"

import "./NeonTitle.vue?vue&type=style&index=0&id=200bbad4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-200bbad4"]])

export default __exports__